// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__njmJp","content":"styles_content__-3iZq","checkbox":"styles_checkbox__UDdaL","weight":"styles_weight__Hvvca","reorder":"styles_reorder__niANL"};